module.exports = __webpack_public_path__ + "node_modules/react-native-vector-icons/Fonts/FontAwesome.ttf";